function removeDuplicateNamespaces(
  selector: string,
  namespace: string
): string {
  const escaped = namespace.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const pattern = new RegExp(`${escaped}\\s+([^\\s]*?)${escaped}\\s+`, 'g');
  const namespaceCount = selector.split(namespace).length - 1;

  let result = selector;
  for (let i = 0; i < namespaceCount - 1; i++) {
    result = result.replace(pattern, `${namespace} $1`);
  }
  return result;
}

// We export this separately so teams that need this can create custom sheet
// managers that inject a custom namespace into the plugin.
const namespacePlugin = (namespace: string) => {
  function plugin(context: number, _: any, selectors: string[]) {
    if (namespace && context === 2) {
      for (let i = 0; i < selectors.length; i++) {
        const selector = selectors[i];
        if (selector.startsWith('.')) {
          const normalized = selector.replace(/\s+/g, ' ');

          // Fast duplicate detection using split (faster than includes for this case)
          if (normalized.split(namespace).length > 2) {
            selectors[i] = removeDuplicateNamespaces(normalized, namespace);
          } else if (!selector.startsWith(`${namespace} `)) {
            selectors[i] = `${namespace} ${selector}`;
          }
        }
      }
    }
  }

  // Use Object.defineProperty to set the name in a way that survives
  // minification. Styled components needs it's plugins to have a name.
  Object.defineProperty(plugin, 'name', {
    value: `namespacePlugin-${namespace}`,
  });

  return plugin;
};

export default namespacePlugin;
